// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fg-CG","comment":"styles_comment__2baS8"};